import React from 'react';
import './WhatsAppButton.css';

function WhatsAppButton() {
  const phoneNumber = '917906769090'; // +91 79067 69090
  const message = 'hi';
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={whatsappUrl}
      className="whatsapp-button"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
    >
      <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
        <path fill="currentColor" d="M16 0C7.164 0 0 7.164 0 16c0 2.825.735 5.48 2.023 7.784L.694 30.828l7.365-1.932A15.896 15.896 0 0016 32c8.836 0 16-7.164 16-16S24.836 0 16 0zm0 29.333A13.293 13.293 0 018.987 27.2l-.446-.265-4.626 1.213 1.235-4.508-.292-.462A13.238 13.238 0 012.667 16c0-7.364 5.97-13.333 13.333-13.333S29.333 8.636 29.333 16 23.364 29.333 16 29.333zm7.307-9.973c-.4-.2-2.37-1.169-2.736-1.302-.368-.133-.635-.2-.902.2-.268.4-1.034 1.302-1.268 1.569-.234.268-.468.301-.868.1-.4-.2-1.688-.622-3.215-1.983-1.188-1.06-1.99-2.368-2.224-2.768-.234-.4-.025-.616.175-.816.18-.179.4-.467.6-.701.2-.234.268-.4.4-.668.134-.268.067-.501-.033-.701-.1-.2-.902-2.173-1.236-2.973-.324-.778-.655-.672-.902-.685-.234-.012-.501-.015-.768-.015s-.702.1-1.069.501c-.368.4-1.402 1.369-1.402 3.34 0 1.97 1.436 3.874 1.636 4.142.2.268 2.825 4.314 6.846 6.051.956.413 1.703.66 2.285.845.96.305 1.835.262 2.527.159.771-.115 2.37-.969 2.704-1.903.334-.935.334-1.736.234-1.903-.1-.168-.368-.268-.768-.468z"/>
      </svg>
      <span className="whatsapp-tooltip">Chat with us</span>
    </a>
  );
}

export default WhatsAppButton;
